import { render } from "./F012BpdfValidador.vue?vue&type=template&id=764d2e31"
import script from "./F012BpdfValidador.vue?vue&type=script&lang=js"
export * from "./F012BpdfValidador.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__